module.exports = __webpack_public_path__ + "static/media/map_only_CH.963bcd33.png";